export const createKey = (params: any): string => {
  const searchParams = new URLSearchParams();

  Object.keys(params).forEach(key => {
    const value = params[key];

    if (value !== null && value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach(item => {
          searchParams.append(key, item);
        });
      } else {
        searchParams.set(key, value);
      }
    } else {
      searchParams.delete(key);
    }
  });

  return searchParams.toString() === '' ? '' : `?${searchParams.toString()}`;
};

export const readKey = (queryString: string): any => {
  const params = new URLSearchParams(queryString);
  const result: any = {};

  params.forEach((value, key) => {
    // If the key already exists, convert it into an array or add to it
    if (result[key]) {
      if (Array.isArray(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      // If the key doesn't exist, simply add the key-value pair
      result[key] = value;
    }
  });

  return result;
};
